"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportNotificationTitle = exports.ExportNotificationContent = void 0;
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const export_notification_detail_1 = require("./export.notification.detail/export.notification.detail");
const export_notification_detail_ctrl_1 = require("./export.notification.detail/export.notification.detail.ctrl");
const export_notification_style_1 = require("./export.notification.style");
(0, theme_1.addStyles)(export_notification_style_1.Style);
function viewNotificationDetail(notificationEntries, collection) {
    return notificationEntries.map((notificationEntry) => {
        const detailCtrl = new export_notification_detail_ctrl_1.ExportNotificationDetailCtrl(notificationEntry, collection);
        return export_notification_detail_1.ExportNotificationDetail.view(detailCtrl);
    });
}
function viewContent(ctrl) {
    const children = ctrl.notifications.map((notification) => {
        const revision = notification.revision;
        const collection = ctrl.getCollection(revision);
        const entries = ctrl.errors ? notification.errors : notification.warnings;
        return (0, mithril_1.m)('div', { className: export_notification_style_1.CSS.section }, [
            (0, mithril_1.m)('span', ctrl.getTitleFieldName(revision) + ': '),
            (0, mithril_1.m)('span', { className: export_notification_style_1.CSS.title }, collection.title),
            (0, mithril_1.m)('ul', { className: export_notification_style_1.CSS.content }, viewNotificationDetail(entries, collection)),
        ]);
    });
    return (0, mithril_1.m)('div', { className: export_notification_style_1.CSS.container }, children);
}
function viewTitle(ctrl) {
    return ctrl.errors ? (0, i18n_1.Translate)(i18n_1.T.NOTIFICATION_ERROR_TITLE) : (0, i18n_1.Translate)(i18n_1.T.NOTIFICATION_WARNING_TITLE);
}
exports.ExportNotificationContent = { view: viewContent };
exports.ExportNotificationTitle = { view: viewTitle };
//# sourceMappingURL=export.notification.js.map